// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"993ee3a5cee3b98d","4454":"3430e20ca5bfb3b2"}[chunkId] + ".css";
};